import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ozy_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status >= 500 || !e?.response ? "Service momentanément indisponible. Réessayez dans quelques minutes." : e?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}

let MONEY = "fr-FR";
/** Format monétaire selon la langue du site : 16,99 € (français) ou €16.99 (anglais). */
export const setMoneyLocale = (lang) => { MONEY = lang === "en" ? "en-IE" : "fr-FR"; };

export const euro = (n) =>
  new Intl.NumberFormat(MONEY, { style: "currency", currency: "EUR", maximumFractionDigits: Number.isInteger(n) ? 0 : 2 }).format(n ?? 0);

const IMG = "/editorial/";
export const IMAGES = {
  heroAfro: IMG + "cheveux-afro-boucles-volumineux.webp",
  heroEuro: IMG + "femme-afro-naturelle.webp",
  heroCurly: IMG + "femme-europeenne-cheveux-boucles.webp",
  locks: IMG + "soins-locks.webp",
  barbe: IMG + "soin-barbe-afro.webp",
  visage: IMG + "soins-visage-corps.webp",
  kids: IMG + "cheveux-crepus-enfants.webp",
  prestige: IMG + "coffret-vrais-produits-ozentya.webp",
};

export const imgUrl = (src) => (typeof src === "string" && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src || undefined);

export const CATEGORIES = ["Pousse", "Locks", "Barbe", "Soins visage", "Soins du corps", "Kids"];
